import { IconButton, Tooltip, Chip, OutlinedInput, InputAdornment } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getProductTypesAction } from "../../redux/actions/ProductTypeactions";

const ProDependency = ({ proDep, setProDep }) => {
  const dispatch = useDispatch();
  const productTypesList = useSelector((state) => state.productTypes);
  const { loading, error, productTypes } = productTypesList;
  const userLogin = useSelector((state) => state.userSignIn);
  const { userInfo } = userLogin;

  useEffect(() => {
    dispatch(getProductTypesAction(userInfo.token));
  }, []);

  // Add a product dependency when clicked
  function addTag(productName) {
    if (!proDep.includes(productName)) {
      setProDep([...proDep, productName]);
    }
  }

  // Remove a selected product dependency
  function removeTag(index) {
    setProDep(proDep.filter((_, i) => i !== index));
  }

  return (
    <>
      {/* Label with Tooltip */}
      <label className="form-label d-flex align-items-center text-white">
        Product Dependency
        <Tooltip
          title={
            <span style={{ fontSize: ".8rem" }}>
              Indicate which products are dependent on this item. Click a product type below to add it as a dependency.
            </span>
          }
          arrow
        >
          <IconButton size="small" className="ms-2 text-primary">
            <HelpOutlineIcon fontSize="inherit" />
          </IconButton>
        </Tooltip>
      </label>

      {/* Modern Input Field with Selected Chips */}
      <OutlinedInput
        fullWidth
        placeholder="Selected dependencies will appear here..."
        value=""
        startAdornment={
          <InputAdornment position="start">
            {proDep.map((tag, index) => (
              <Chip
                key={index}
                label={tag}
                onDelete={() => removeTag(index)}
                className="me-1"
                color="primary"
                size="small"
              />
            ))}
          </InputAdornment>
        }
        readOnly
      />

      {/* Available product types (click to add) */}
      <div className="row g-2 mt-2">
        {loading ? (
          <p>Loading product types...</p>
        ) : error ? (
          <p className="text-danger">Failed to load product types: {error}</p>
        ) : (
          productTypes.map((product, index) => (
            <div className="col-auto" key={index}>
              <button
                className={`btn btn-sm ${
                  proDep.includes(product.name) ? "btn-secondary disabled" : "btn-outline-primary"
                }`}
                onClick={() => addTag(product.name)}
                disabled={proDep.includes(product.name)}
              >
                {product.name}
              </button>
            </div>
          ))
        )}
      </div>
    </>
  );
};

export default ProDependency;
